import { gql } from "apollo-boost";

export const CREATE_COUNT = gql`
mutation CreatecountSiter {
  createcountSiter {
    id
  }
}
`